// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'babel-polyfill'
import axios from 'axios'
import promise from 'es6-promise'
promise.polyfill() //处理ie兼容
// 引入echarts
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts 

// import  VueAwesomeSwiper from 'vue-awesome-swiper'
// import  'swiper/dist/css/swiper.css'
// Vue.use(VueAwesomeSwiper)

import store from './vuex'

//qs
import qs from 'qs';

//element-ui
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import {
  Message
} from 'element-ui';
Vue.use(ElementUi);

//全局进度条配置
import NProgress from "nprogress" //导入进度条插件
import 'nprogress/nprogress.css'
NProgress.inc(0.5) //简单配置进度条
NProgress.configure({
  easing: 'ease',
  speed: 500,
  showSpinner: false
})
router.beforeEach((to, from, next) => { //设置触发时机
  NProgress.start();
  if (to.fullPath == '/link?login=1&loginTyoe=0') { //如果是去登录页面，就把上一个页面保存下来，登录并返回登录前页面会用到
    window.localStorage.setItem('fullPath', from.fullPath)
  }
  next()
})
router.afterEach(() => { //进度条消失时机
  NProgress.done();
});


import router from './router'
//axios全局配置
axios.defaults.withCredentials = true; //设置ajax请求时带cookie
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
Vue.prototype.$axios = axios;
axios.interceptors.request.use( //设置请求拦截器，每次请求都带上sessionId
  config => {
    if (window.localStorage.getItem('sessionId')) {
      config.headers.common['sessionId'] = window.localStorage.getItem('sessionId');
    }
    if (window.localStorage.getItem('account')) {
      config.headers.common['token'] = window.localStorage.getItem('account');
    }
    if (window.localStorage.getItem('memId')) {
      config.headers.common['userCode'] = window.localStorage.getItem('memId');
    }
    return config;
  },
  err => {
    return Promise.reject(err)
  }
)
axios.interceptors.response.use(function (response) { //设置返回拦截器，请求失败则返回登录界面
    if (response.data == "555555" || response.data == '666666') {
      window.localStorage.removeItem("account");
      window.localStorage.removeItem("sessionId");
      window.localStorage.removeItem("role");
      window.localStorage.removeItem("openID");
      window.localStorage.removeItem("unionid");
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("curTime");
      router.replace({
          path:'/link?login=1&loginTyoe=0',
          // query:{redirect:router.currentRoute.fullPath}
      });
      Message.error('登录过期，请重新登录')
      return;
    }
    return response; //这句一定不能注释或者删除
  },
  err => {
    return Promise.reject(err)
  }
)
function GetDateStr(AddDayCount) {
  var dd = new Date();
  dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
  var y = dd.getFullYear();
  var m = (dd.getMonth()+1)<10?"0"+(dd.getMonth()+1):(dd.getMonth()+1);//获取当前月份的日期，不足10补0
  var d = dd.getDate()<10?"0"+dd.getDate():dd.getDate();//获取当前几号，不足10补0
  return y+"-"+m+"-"+d;
}
function deepClone(source){
  const targetObj = source.constructor === Array ? [] : {}; // 判断复制的目标是数组还是对象
  for(let keys in source){ // 遍历目标
    if(source.hasOwnProperty(keys)){
      if(source[keys] && typeof source[keys] === 'object'){ // 如果值是对象，就递归一下
        targetObj[keys] = source[keys].constructor === Array ? [] : {};
        targetObj[keys] = deepClone(source[keys]);
      }else{ // 如果不是，就直接赋值
        targetObj[keys] = source[keys];
      }
    }
  }
  return targetObj;
}
Vue.prototype.deepClone = deepClone;
Vue.prototype.GetDateStr = GetDateStr;


Vue.config.productionTip = false

const root = process.env.API_ROOT;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
  created() { //seo处理
    var title = document.getElementsByTagName('title');
    var description = document.getElementById('description');
    var keywords = document.getElementById('keywords');
    this.$axios.get(root + '/index/seo').then(res => {
      var seo = res.data.seo;
      var arr1 = seo[0].keyWords.split('、');
      var arr2 = arr1.join(',');
      description["content"] = seo[0].desc;
      keywords["content"] = arr2;
      title[0].innerText = seo[0].title;
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js